import { jsxs as l, jsx as L } from "react/jsx-runtime";
const d = ({ size: i = 24, ...h }) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    ...h,
    children: [
      /* @__PURE__ */ L("g", { clipPath: "url(#clip0_8748_961)", children: /* @__PURE__ */ l("g", { clipPath: "url(#clip1_8748_961)", children: [
        /* @__PURE__ */ L("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M-4 0H28V24H-4V0Z", fill: "#00247D" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 6.22437V6.89203L19.3079 6.22437H17.9726Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.2397 7.02556L17.9726 6.49143L19.3079 6.22437L18.2397 7.02556Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 6.22437V6.89203L16.6373 6.22437H17.9726Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.7055 7.02556L17.9726 6.49143L16.6373 6.22437L17.7055 7.02556Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.3536 6.50122L17.7186 6.70754L18.7662 7.77119L18.3536 6.50122Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.6741 7.0028L18.0996 6.58375L18.7662 7.77119L17.6741 7.0028Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.5916 6.50122L18.2266 6.70754L18.0043 5.23125L17.5916 6.50122Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.4361 6.49481L17.8456 6.58375L18.0043 5.23125L18.4361 6.49481Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.5916 6.50122L18.2266 6.70754L17.179 7.77119L17.5916 6.50122Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.2711 7.0028L17.8456 6.58375L17.179 7.77119L18.2711 7.0028Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.9725 6.36011V6.80129L18.8549 6.36011H17.9725Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M18.149 6.88953L17.9725 6.53658L18.8549 6.36011L18.149 6.88953Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.9725 6.36011V6.80129L17.0902 6.36011H17.9725Z", fill: "#CC142B" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M17.7961 6.88953L17.9725 6.53658L17.0902 6.36011L17.7961 6.88953Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M18.2243 6.54321L17.8047 6.67955L18.497 7.3824L18.2243 6.54321Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.7753 6.87465L18.0565 6.59775L18.497 7.3824L17.7753 6.87465Z", fill: "#CC142B" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M17.7208 6.54321L18.1404 6.67955L17.9935 5.70403L17.7208 6.54321Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M18.2789 6.53898L17.8887 6.59775L17.9935 5.70403L18.2789 6.53898Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M17.7208 6.54321L18.1404 6.67955L17.4482 7.3824L17.7208 6.54321Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M18.1698 6.87465L17.8887 6.59775L17.4482 7.3824L18.1698 6.87465Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M21.4714 9.30591L21.4714 9.90004L22.6596 9.30591L21.4714 9.30591Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.709 10.0189L21.4714 9.54356L22.6596 9.30591L21.709 10.0189Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.4714 9.30591L21.4714 9.90004L20.2831 9.30591L21.4714 9.30591Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.2337 10.0189L21.4714 9.54356L20.2831 9.30591L21.2337 10.0189Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.8104 9.55225L21.2454 9.73584L22.1776 10.6823L21.8104 9.55225Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.2058 9.99858L21.5844 9.62568L22.1776 10.6823L21.2058 9.99858Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.1324 9.55225L21.6974 9.73584L21.4996 8.42214L21.1324 9.55225Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.8839 9.54654L21.3584 9.62568L21.4996 8.42214L21.8839 9.54654Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.1324 9.55225L21.6974 9.73584L20.7652 10.6823L21.1324 9.55225Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M21.737 9.99858L21.3584 9.62568L20.7652 10.6823L21.737 9.99858Z", fill: "white" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.4715 9.44165L21.4715 9.80931L22.2068 9.44165L21.4715 9.44165Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.6186 9.88284L21.4715 9.58871L22.2068 9.44165L21.6186 9.88284Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.4715 9.44165L21.4715 9.80931L20.7362 9.44165L21.4715 9.44165Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.3244 9.88284L21.4715 9.58871L20.7362 9.44165L21.3244 9.88284Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.6813 9.59424L21.3316 9.70785L21.9085 10.2936L21.6813 9.59424Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.3071 9.87044L21.5414 9.63968L21.9085 10.2936L21.3071 9.87044Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.2617 9.59424L21.6114 9.70785L21.4889 8.89492L21.2617 9.59424Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.7268 9.59071L21.4016 9.63968L21.4889 8.89492L21.7268 9.59071Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.2617 9.59424L21.6114 9.70785L21.0345 10.2936L21.2617 9.59424Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M21.6359 9.87044L21.4016 9.63968L21.0345 10.2936L21.6359 9.87044Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M14.6579 11.3276L14.6579 11.9953L15.9932 11.3276L14.6579 11.3276Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.925 12.1288L14.6579 11.5947L15.9932 11.3276L14.925 12.1288Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.6579 11.3276L14.6579 11.9953L13.3226 11.3276L14.6579 11.3276Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.3908 12.1288L14.6579 11.5947L13.3226 11.3276L14.3908 12.1288Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M15.0389 11.6045L14.4039 11.8108L15.4515 12.8745L15.0389 11.6045Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.3594 12.1061L14.7849 11.687L15.4515 12.8745L14.3594 12.1061Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.2769 11.6045L14.9119 11.8108L14.6896 10.3345L14.2769 11.6045Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M15.1214 11.5981L14.5309 11.687L14.6896 10.3345L15.1214 11.5981Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.2769 11.6045L14.9119 11.8108L13.8643 12.8745L14.2769 11.6045Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M14.9564 12.1061L14.5309 11.687L13.8643 12.8745L14.9564 12.1061Z", fill: "white" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.6579 11.4634L14.6579 11.9046L15.5403 11.4634L14.6579 11.4634Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.8344 11.9928L14.6579 11.6399L15.5403 11.4634L14.8344 11.9928Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.6579 11.4634L14.6579 11.9046L13.7755 11.4634L14.6579 11.4634Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.4814 11.9928L14.6579 11.6399L13.7755 11.4634L14.4814 11.9928Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.9097 11.6462L14.4901 11.7826L15.1823 12.4854L14.9097 11.6462Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.4607 11.9777L14.7418 11.7008L15.1823 12.4854L14.4607 11.9777Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.4062 11.6462L14.8258 11.7826L14.6789 10.8071L14.4062 11.6462Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M14.9642 11.642L14.574 11.7008L14.6789 10.8071L14.9642 11.642Z", fill: "#CC142B" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M14.4062 11.6462L14.8258 11.7826L14.1335 12.4854L14.4062 11.6462Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M14.8552 11.9777L14.574 11.7008L14.1335 12.4854L14.8552 11.9777Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 17.0083V17.7495L19.455 17.0083H17.9726Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.2691 17.8977L17.9726 17.3048L19.455 17.0083L18.2691 17.8977Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 17.0083V17.7495L16.4902 17.0083H17.9726Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.6761 17.8977L17.9726 17.3048L16.4902 17.0083L17.6761 17.8977Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.3956 17.3154L17.6907 17.5445L18.8537 18.7253L18.3956 17.3154Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.6413 17.8722L18.1136 17.407L18.8537 18.7253L17.6413 17.8722Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.5497 17.3154L18.2546 17.5445L18.0078 15.9056L17.5497 17.3154Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.4872 17.3083L17.8316 17.407L18.0078 15.9056L18.4872 17.3083Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.5497 17.3154L18.2546 17.5445L17.0916 18.7253L17.5497 17.3154Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M18.304 17.8722L17.8316 17.407L17.0916 18.7253L18.304 17.8722Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 17.144V17.6588L19.002 17.144H17.9726Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M18.1785 17.7617L17.9726 17.3499L19.002 17.144L18.1785 17.7617Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.9726 17.144V17.6588L16.9432 17.144H17.9726Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.7667 17.7617L17.9726 17.3499L16.9432 17.144L17.7667 17.7617Z", fill: "#CC142B" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M18.2663 17.3574L17.7768 17.5165L18.5844 18.3365L18.2663 17.3574Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M17.7425 17.7441L18.0705 17.421L18.5844 18.3365L17.7425 17.7441Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M17.6789 17.3574L18.1684 17.5165L17.997 16.3784L17.6789 17.3574Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M18.3299 17.3525L17.8747 17.421L17.997 16.3784L18.3299 17.3525Z", fill: "#CC142B" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M17.6789 17.3574L18.1684 17.5165L17.3608 18.3365L17.6789 17.3574Z",
            fill: "#CC142B"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M18.2027 17.7441L17.8747 17.421L17.3608 18.3365L18.2027 17.7441Z", fill: "#CC142B" }),
        /* @__PURE__ */ L("path", { d: "M-4 0H12V12H-4V0Z", fill: "#012169" }),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M-2.125 0L3.975 4.525L10.05 0H12V1.55L6 6.025L12 10.475V12H10L4 7.525L-1.975 12H-4V10.5L1.975 6.05L-4 1.6V0H-2.125Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M6.6 7.025L12 11V12L5.225 7.025H6.6ZM2 7.525L2.15 8.4L-2.65 12H-4L2 7.525ZM12 0V0.075L5.775 4.775L5.825 3.675L10.75 0H12ZM-4 0L1.975 4.4H0.475L-4 1.05V0Z",
            fill: "#C8102E"
          }
        ),
        /* @__PURE__ */ L("path", { d: "M2.025 0V12H6.025V0H2.025ZM-4 4V8H12V4H-4Z", fill: "white" }),
        /* @__PURE__ */ L("path", { d: "M-4 4.825V7.225H12V4.825H-4ZM2.825 0V12H5.225V0H2.825Z", fill: "#C8102E" })
      ] }) }),
      /* @__PURE__ */ l("defs", { children: [
        /* @__PURE__ */ L("clipPath", { id: "clip0_8748_961", children: /* @__PURE__ */ L("rect", { width: "24", height: "24", rx: "12", fill: "white" }) }),
        /* @__PURE__ */ L("clipPath", { id: "clip1_8748_961", children: /* @__PURE__ */ L("rect", { width: "32", height: "24", fill: "white", transform: "translate(-4)" }) })
      ] })
    ]
  }
);
export {
  d as RegionNewZealandIcon
};
